'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DingShare = exports.WeiXinShare = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aps = require('@ali/aps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QrCodeShare = function (_Component) {
  _inherits(QrCodeShare, _Component);

  function QrCodeShare(props) {
    _classCallCheck(this, QrCodeShare);

    var _this = _possibleConstructorReturn(this, (QrCodeShare.__proto__ || Object.getPrototypeOf(QrCodeShare)).call(this, props));

    _this.state = {
      img: null,
      click: false,
      loading: null
    };
    return _this;
  }

  _createClass(QrCodeShare, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var shareInstance, PC;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                shareInstance = window.$ACE.Share.create();
                PC = shareInstance.createPC();

                this.PC = PC;
                this.setImage(this.props.url);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'track',
    value: function track() {
      if (this.type == 'weixin') {
        // 悬浮框点击后，才会去发起打点请求
        this.PC.weixinTrack();
      } else {
        // 悬浮框点击后，才会去发起打点请求
        this.PC.dingTrack();
      }
    }
  }, {
    key: 'setImage',
    value: function setImage(url) {
      if (this.type == 'weixin') {
        this.setState({ img: this.PC.weixin({ url: url }) });
        if (this.click) {
          // 悬浮框点击后，才会去发起打点请求
          this.PC.weixinTrack();
        }
      } else {
        this.setState({ img: this.PC.ding({ url: url }) });
        if (this.click) {
          // 悬浮框点击后，才会去发起打点请求
          this.PC.dingTrack();
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url != this.props.url) {
        var url = nextProps.url;
        if (!url) {
          return this.setState({ img: null });
        }
        this.setImage(url);
      }
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return _react2.default.createElement(
        'div',
        { style: { textAlign: 'center', paddingTop: '20px' } },
        _react2.default.createElement(_aps.Icon, { type: 'loading', spin: true }),
        _react2.default.createElement(
          'p',
          null,
          '\u52A0\u8F7D\u4E2D...'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { onClick: function onClick() {
            _this2.props.onClick && _this2.props.onClick();
          }, className: 'share-button-wrapper' },
        _react2.default.createElement(
          _aps.Tooltip,
          {
            theme: 'light',
            direction: 'top',
            align: 'center',
            triggerType: 'click',
            trigger: _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  _this2.track();
                } },
              this.props.children
            )
          },
          _react2.default.createElement(
            'div',
            { className: 'qrcode-wrapper' },
            !this.props.loading ? _react2.default.createElement('img', { src: this.state.img, style: { display: this.state.img ? 'block' : 'none' } }) : this.renderLoading()
          )
        )
      );
    }
  }]);

  return QrCodeShare;
}(_react.Component);

var WeiXinShare = exports.WeiXinShare = function (_QrCodeShare) {
  _inherits(WeiXinShare, _QrCodeShare);

  function WeiXinShare(props) {
    _classCallCheck(this, WeiXinShare);

    var _this3 = _possibleConstructorReturn(this, (WeiXinShare.__proto__ || Object.getPrototypeOf(WeiXinShare)).call(this, props));

    _this3.type = 'weixin';
    return _this3;
  }

  return WeiXinShare;
}(QrCodeShare);

var DingShare = exports.DingShare = function (_QrCodeShare2) {
  _inherits(DingShare, _QrCodeShare2);

  function DingShare(props) {
    _classCallCheck(this, DingShare);

    var _this4 = _possibleConstructorReturn(this, (DingShare.__proto__ || Object.getPrototypeOf(DingShare)).call(this, props));

    _this4.type = 'ding';
    return _this4;
  }

  return DingShare;
}(QrCodeShare);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/react-util/lib/qr-code.js
// module id = 228
// module chunks = 0 1